import { createFileRoute, redirect } from '@tanstack/react-router'
import { createProductionDashboardConfigSearch } from 'routes/production-dashboard/-searchParams'
import { Route as NewRoute } from 'routes/production-dashboard/config'

export const Route = createFileRoute(
  '/production-dashboard/(deprecated_routes)/$orgID/$siteID/$configID'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: NewRoute.to,
      search: (prev) => ({
        ...prev,
        ...createProductionDashboardConfigSearch({
          orgId: params.orgID,
          siteId: params.siteID,
          configId: params.configID,
        }),
      }),
      replace: true,
    })
  },
})
